export default {
      Users: 'User|Users',

};
